import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { AppButton } from 'components/no-auth/common/app-button/AppButton';
import { PromoButton } from 'components/no-auth/common/promo-button/PromoButton';
import { PromoText } from 'components/no-auth/common/promo-text/PromoText';
import { PromoRow } from 'components/no-auth/common/PromoRow/PromoRow';

import { URL_IMAGES_I } from 'constants/UrlConstants';

import promoMedia from 'theme/promoMedia';

import PromoComplexPopup from '../../popup/PromoComplexPopup';
import { ComplexPopupRow } from '../../popup/styles';

const QrCode = styled.figure`
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    width: 136px;
    margin-bottom: 32px;

    img {
        border: none;
        max-width: 100%;
        vertical-align: top;
    }

    ${promoMedia.tablet744} {
        width: 224px;
    }
`;

function QRPopup(props) {
    const chinaChat = props.chinaChat;

    const getPicture = () =>
        chinaChat ? (
            <picture>
                <source media="(min-width: 736px)" srcSet={`${URL_IMAGES_I}/qr-code-1x-d.png 1x, ${URL_IMAGES_I}/qr-code-2x-d.png 2x`} />
                <source srcSet={`${URL_IMAGES_I}/qr-code-1x-m.png 1x, ${URL_IMAGES_I}/qr-code-2x-m.png 2x`} />
                <img loading="lazy" decoding="async" alt="Scan to join PaySend WeChat" src={`${URL_IMAGES_I}/qr-code-1x-m.png`} />
            </picture>
        ) : (
            <picture>
                <source media="(min-width: 736px)" srcSet={`${URL_IMAGES_I}/smart-qr-code-1x-d.png 1x, ${URL_IMAGES_I}/smart-qr-code-2x-d.png 2x`} />
                <source srcSet={`${URL_IMAGES_I}/smart-qr-code-1x-m.png 1x, ${URL_IMAGES_I}/smart-qr-code-2x-m.png 2x`} />
                <img loading="lazy" decoding="async" alt="Scan to join PaySend" src={`${URL_IMAGES_I}/smart-qr-code-1x-m.png`} />
            </picture>
        );

    return (
        <PromoComplexPopup withoutButton textCenter popupRef={props.popupRef}>
            <ComplexPopupRow>
                <PromoText color="gray40" tag="div" variant="subheader">
                    {chinaChat ? props.messages.qrWeChatMessage : props.qrTitle}
                </PromoText>
            </ComplexPopupRow>
            <QrCode>{getPicture()}</QrCode>
            {props.hasAppsBtns ? (
                <PromoRow flex direction="column" align="center">
                    <PromoRow indent="adaptive-12-16">
                        <AppButton href={props.apple_store} variant="apple" areaLabel="App Store" />
                    </PromoRow>
                    <PromoRow indent="adaptive-12-16">
                        <AppButton href={props.google_play} variant="google" areaLabel="Google Play" />
                    </PromoRow>
                    <PromoRow indent="adaptive-12-16">
                        <AppButton href={props.huawei_store} variant="huawei" areaLabel="AppGallery" />
                    </PromoRow>
                </PromoRow>
            ) : (
                <ComplexPopupRow>
                    <PromoButton caption={props.qrBtnTitle} onClick={() => props.popupRef.current?.close()} variant="primary" isInverted />
                </ComplexPopupRow>
            )}
        </PromoComplexPopup>
    );
}

QRPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    hasAppsBtns: PropTypes.bool,
    qrTitle: PropTypes.string,
    apple_store: PropTypes.string,
    google_play: PropTypes.string,
    huawei_store: PropTypes.string,
    qrBtnTitle: PropTypes.string,
};

const mapStateToProps = (state) => {
    return {
        messages: state.messages?.pageMessages,
        qrTitle: state.extra?.downloadButtons?.find((item) => item.type === 'qr')?.title,
        qrBtnTitle: state.extra?.downloadButtons?.find((item) => item.type === 'qr')?.buttonTitle,
        apple_store: state.extra?.downloadButtons?.find((item) => item.type === 'apple')?.url,
        google_play: state.extra?.downloadButtons?.find((item) => item.type === 'android')?.url,
        huawei_store: state.extra?.downloadButtons?.find((item) => item.type === 'huawei')?.url,
    };
};
export default connect(mapStateToProps, null)(QRPopup);
